import { ResetPasswordView } from "@components";

export const ResetPassword = () => {
    return (
        <>
            <ResetPasswordView />
        </>
    );
};
